import React, { FunctionComponent } from "react";
import { useI18n } from "../../../../hooks/useI18n";
import MaterialTable, { MTableToolbar } from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { Paper } from "@material-ui/core";
import useStyles from "./styles";
import { StatTableProps } from "./types";

const StatTable = ({
  exportName,
  isLoading,
  dense,
  columns,
  data,
  detailPanel,
  actions,
  pageSize,
  pageSizeOptions,
  hideDetailPanel,
  noSearch
}: StatTableProps) => {
  const classes = useStyles();
  const { t } = useI18n();

  return (
    <MaterialTable
      title=""
      isLoading={isLoading}
      columns={columns}
      data={data}
      detailPanel={detailPanel}
      actions={actions}
      options={{
        actionsColumnIndex: -1,
        detailPanelColumnStyle: { display: hideDetailPanel ? "none" : "" },
        detailPanelType: "single",
        headerStyle: {
          padding: dense ? "8px" : "",
          backgroundColor: "#05598d",
          color: "#fff",
          fontWeight: "bold"
        },
        exportMenu: exportName
          ? [
              {
                label: t("common.export.exportPdf"),
                exportFunc: (cols, data) => ExportPdf(cols, data, exportName)
              },
              {
                label: t("common.export.exportCsv"),
                exportFunc: (cols, data) => ExportCsv(cols, data, exportName)
              }
            ]
          : [],
        search: !noSearch,
        exportAllData: true,
        paging: true,
        pageSize: pageSize ? pageSize : 10,
        emptyRowsWhenPaging: true,
        pageSizeOptions: pageSizeOptions ? pageSizeOptions : [10, 15, 20]
      }}
      components={
        dense
          ? {
              Container: props => <Paper {...props} elevation={0} />,
              Toolbar: props => (
                <div style={{ height: "45px" }} className={classes.toolbar}>
                  <MTableToolbar {...props} />
                </div>
              )
            }
          : {
              Container: props => (
                <Paper {...props} elevation={0} variant="outlined" />
              )
            }
      }
      localization={{
        header: {
          actions: ""
        }
      }}
    />
  );
};
export default StatTable;
